export const isLocationConfirmed = state => state.getIn(['storage', 'data', 'confirmLocation']) || false;
export const getDetails = state => state.getIn(['storage', 'data']);
export const getDetail = (state, detail) => state.getIn(['storage', 'data', detail]);
export const isInitialized = state => state.getIn(['storage', 'initialized']);
